import { useAppStore } from "../../../store";
import { Spin } from "antd";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function ContainerRender(_ref) {
  var app = _ref.app,
    isLoading = _ref.isLoading,
    children = _ref.children;
  var microAppContainerRender = useAppStore(function (s) {
    return s.microAppContainerRender;
  });
  if (microAppContainerRender) {
    var result = microAppContainerRender({
      app: app,
      isLoading: isLoading,
      children: children
    });
    return result || /*#__PURE__*/_jsx(Spin, {
      spinning: isLoading,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Spin, {
    spinning: isLoading,
    children: children
  });
}, function (prev, next) {
  return prev.isLoading === next.isLoading;
});